import { DialogButtons, DialogCustomButtonType, DialogResults, useTranslation } from '@msdk/common'
import { ButtonIcon, COLORS, Typography } from '@msdk/ui'
import React from 'react'

import { useDialogModal } from '../../../hooks'
import { useDynamicViewContext } from '../context'

export function SetAsDefaultButton() {
  const t = useTranslation()
  const { columns, canPersistColumnsLayout, setPersistedColumnsLayout } = useDynamicViewContext()
  const { createModal } = useDialogModal()

  async function showSetAsDefaultPopup() {
    const result = await createModal(
      t('LBL_TABLE_MANAGEMENT_SET_AS_DEFAULT_LAYOUT_TITLE', 'Set default column layout'),
      t(
        'LBL_TABLE_MANAGEMENT_SET_AS_DEFAULT_LAYOUT_MESSAGE',
        'This will set the currently selected column layout as the default column layout for all clinic users.',
      ),
      DialogButtons.Custom,
      [
        {
          label: t('CMPSR_CANCEL', 'Cancel'),
          result: DialogResults.Cancel,
          type: DialogCustomButtonType.Secondary,
        },
        {
          label: t('LBL_TABLE_MANAGEMENT_SET_AS_DEFAULT', 'Set as default'),
          result: DialogResults.Ok,
          type: DialogCustomButtonType.Primary,
        },
      ],
    )

    if (result === DialogResults.Ok) {
      await setPersistedColumnsLayout(columns)
    }
  }

  if (!canPersistColumnsLayout) return <></>

  return (
    <ButtonIcon onClick={showSetAsDefaultPopup}>
      <Typography variant="button" color={COLORS.primary.main}>
        {t('LBL_TABLE_MANAGEMENT_SET_AS_DEFAULT', 'Set as default')}
      </Typography>
    </ButtonIcon>
  )
}
